import { render, staticRenderFns } from "./BreadTabulatorFormSelectModel.vue?vue&type=template&id=530aa61c&"
import script from "./BreadTabulatorFormSelectModel.vue?vue&type=script&lang=js&"
export * from "./BreadTabulatorFormSelectModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
